import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useReducer } from 'react';
import { useDebounce } from '../../../hooks';
import { useReadonlyNetworks } from '../../network';
import { BlockNumbersContext } from './context';
import { blockNumberReducer } from '../common/reducer';
import { subscribeToNewBlock } from '../common/subscribeToNewBlock';
import { useWindow } from '../../window';
import { useIsMounted } from '../../../hooks/useIsMounted';
export function BlockNumbersProvider(_ref) {
  var children = _ref.children;
  var networks = useReadonlyNetworks();
  var _useReducer = useReducer(blockNumberReducer, {}),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var isActive = useWindow();
  var isMounted = useIsMounted();
  useEffect(function () {
    var onUnmount = Object.entries(networks).map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        chainId = _ref3[0],
        provider = _ref3[1];
      return subscribeToNewBlock(provider, Number(chainId), function () {
        if (isMounted()) {
          dispatch.apply(void 0, arguments);
        }
      }, isActive);
    });
    return function () {
      return onUnmount.forEach(function (fn) {
        return fn();
      });
    };
  }, [networks]);
  var debouncedState = useDebounce(state, 100);
  return _jsx(BlockNumbersContext.Provider, {
    value: debouncedState,
    children: children
  });
}